import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { LIFESTYLES } from "@/lib/site";

export const REGIONS = ["Hampton Roads", "Greater Richmond"];
export const lifestyleHref = (id, region) => `/search?lifestyle=${id}&region=${encodeURIComponent(region)}`;
const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

/** Mega dropdown mirroring the Lifestyle menu on 757realty.com (each link opens matching homes). */
export const LifestyleMenu = ({ light }) => (
  <div className="group relative" data-testid="nav-lifestyle">
    <button type="button" className={`flex items-center gap-1 text-[15px] transition-opacity hover:opacity-70 ${light ? "text-white" : "text-ink"}`} data-testid="nav-lifestyle-button" aria-haspopup="true">
      Lifestyle <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover:rotate-180 group-focus-within:rotate-180" />
    </button>
    <div className="invisible absolute left-1/2 top-full z-50 w-[620px] -translate-x-1/2 pt-4 opacity-0 transition-[opacity,visibility] duration-200 group-focus-within:visible group-focus-within:opacity-100 group-hover:visible group-hover:opacity-100">
      <div className="grid grid-cols-2 gap-6 rounded-md border border-neutral-200 bg-white p-6 text-ink shadow-[0_24px_60px_-20px_rgba(0,0,0,0.4)]" data-testid="lifestyle-menu">
        {REGIONS.map((r) => (
          <div key={r}>
            <p className="eyebrow mb-3">{r}</p>
            <ul className="space-y-0.5">
              {LIFESTYLES.map((l) => (
                <li key={l.id}>
                  <Link to={lifestyleHref(l.id, r)} data-testid={`lifestyle-link-${l.id}-${slug(r)}`}
                    className="block rounded px-2 py-1.5 text-[14px] transition-colors hover:bg-neutral-100">
                    {l.label} <span className="text-neutral-500">· {r === "Hampton Roads" ? "Hampton Roads" : "Richmond"}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </div>
);

/** Phone menu version: compact list grouped by region. */
export const LifestyleList = () => (
  <div className="space-y-4 py-3" data-testid="mobile-lifestyle-list">
    {REGIONS.map((r) => (
      <div key={r}>
        <p className="eyebrow mb-1">{r}</p>
        <div className="flex flex-wrap gap-1.5">
          {LIFESTYLES.map((l) => (
            <Link key={l.id} to={lifestyleHref(l.id, r)} data-testid={`mobile-lifestyle-${l.id}-${slug(r)}`}
              className="max-w-full truncate rounded-full border border-neutral-300 px-2.5 py-1 text-[12.5px] text-ink transition-colors hover:border-ink">{l.label}</Link>
          ))}
        </div>
      </div>
    ))}
  </div>
);
